import { render, staticRenderFns } from "./PtmScoreScatterPlot.vue?vue&type=template&id=a73c8228"
import script from "./PtmScoreScatterPlot.vue?vue&type=script&lang=js"
export * from "./PtmScoreScatterPlot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports